import { Navigate, Route, Routes } from 'react-router'
import { useSession } from './api/session'
import { LoginPage } from './pages/LoginPage'
import { InboxPage } from './pages/InboxPage'
import { TagsPage } from './pages/TagsPage'
import { AutoRepliesPage } from './pages/AutoRepliesPage'
import { CannedRepliesPage } from './pages/CannedRepliesPage'
import { TeamPage } from './pages/TeamPage'
import { WhatsAppPage } from './pages/WhatsAppPage'
import { ContactsPage } from './pages/ContactsPage'
import { ContactsImportPage } from './pages/ContactsImportPage'
import { TemplatesPage } from './pages/TemplatesPage'
import { TemplateEditorPage } from './pages/TemplateEditorPage'
import { CampaignsPage } from './pages/CampaignsPage'
import { CampaignEditorPage } from './pages/CampaignEditorPage'
import { AppLayout } from './layouts/AppLayout'

export function App() {
  const { token } = useSession()
  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }
  return (
    <AppLayout>
      <Routes>
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/inbox/:conversationId" element={<InboxPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/contacts/import" element={<ContactsImportPage />} />
        <Route path="/contacts/:contactId" element={<ContactsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/templates/new" element={<TemplateEditorPage />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/campaigns/new" element={<CampaignEditorPage />} />
        <Route path="/campaigns/:campaignId" element={<CampaignEditorPage />} />
        <Route path="/settings/tags" element={<TagsPage />} />
        <Route path="/settings/auto-replies" element={<AutoRepliesPage />} />
        <Route path="/settings/canned-replies" element={<CannedRepliesPage />} />
        <Route path="/settings/team" element={<TeamPage />} />
        <Route path="/settings/whatsapp" element={<WhatsAppPage />} />
        <Route path="*" element={<Navigate to="/inbox" replace />} />
      </Routes>
    </AppLayout>
  )
}
